import React from 'react';
import { Link } from 'react-router-dom'
import Services from '../../api/Services';
import { LanguageContext } from '../../index';
import { useContext } from 'react';
const BlogSidebar = (props) => {

    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const { language } = useContext(LanguageContext);

    return (
        <div className="col-lg-4">
            <div className="sidebar ml-95 rml-0 rmt-100">
                <div className="widget widget-category">
                    <h3 className="widget-title">{language === 'en' ? 'Categories' : 'Kategorie'}</h3>
                    <div className="category-list">
                        <ul className="list-style-one">
                            {Services.en.slice(0, 5).map((service, Sitem) => (
                                <li key={Sitem}><Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>{service.sTitle}</Link></li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="widget widget-recent-posts">
                    <h3 className="widget-title">{language === 'en' ? 'Recent Posts' : 'Najnowsze wpisy'}</h3>
                    <div className="post-list">
                        <ul className="list-style-one">
                            <li><Link onClick={ClickHandler} to="/blog">{language === 'en' ? 'Travel to Spain' : 'Wyjazd do Hiszpanii'}</Link></li>
                            <li><Link onClick={ClickHandler} to="/blog">{language === 'en' ? 'Floorboards and underfloor heating' : 'Deska podłogowa, a ogrzewanie'}</Link></li>
                            <li><Link onClick={ClickHandler} to="/blog">{language === 'en' ? 'Benefits of wooden floorboards' : 'Zalety deski podłogowej'}</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="widget widget-search">
                    <h3 className="widget-title">{language === 'en' ? 'Search' : 'Wyszukaj'}</h3>
                    <form onSubmit={SubmitHandler} className="search-form">
                        <input type="search" required placeholder={language === 'en' ? 'Search...' : 'Szukaj...'} />
                        <button type="submit" className="theme-btn">{language === 'en' ? 'search' : 'szukaj'}</button>
                    </form>
                </div>
            </div>
        </div>
    )

}

export default BlogSidebar;
